import React from 'react'

import { useQuery } from '@apollo/client'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import widgetStyles from '../widgets.module.scss'
import { UPCOMING_MATCHES } from '@graphql/globalwidget/rankings.query'
import CustomLink from '@shared/components/customLink'
import FlagTeam from '@assets/images/placeholder/team-placeholder.svg'
import { convertDt24h, dateCheck } from '@shared-submodule/utils'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import WidgetCardHeader from '../widgetHeader'

const MyImage = dynamic(() => import('@shared/components/myImage'))
const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })

function UpcomingMatches() {
  const { data, loading } = useQuery(UPCOMING_MATCHES, {
    variables: {
      input: {
        nLimit: 5,
        nOrder: 1,
        nSkip: 0,
        sSortBy: 'dStartDate'
      }
    },
    context: { headers: { 'Cache-Control': 'public, max-age=300, s-maxage=600, stale-while-revalidate=420' } }
  })
  return (
    <>
      {data?.listUpcomingMatches?.length !== 0 && (
        <section className={widgetStyles.card}>
          <WidgetCardHeader headerText={'Upcoming Matches'} link={allRoutes.fixturesUpcomingNew} internalLink={true} />
          <div className={styles.list}>
            {data?.listUpcomingMatches?.map((data, i) => {
              return (
                <div key={i} className={`${styles.item} d-flex align-items-center position-relative`}>
                  <div className={styles.flag}>
                    <MyImage
                      src={data?.oTeamA?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamA?.oImg?.sUrl}` : FlagTeam}
                      placeholderImage={FlagTeam}
                      errorImage={FlagTeam}
                      width="162"
                      height="162"
                      autoRadiusImage
                      alt={data?.oTeamA?.oImg?.sText}
                      layout="responsive"
                      sizes="20px"
                    />
                  </div>
                  <span className={styles.abbr}>{data?.oTeamA?.sAbbr}</span>
                  <p className={`${styles.date} flex-grow-1 text-center mb-0`}>{convertDt24h(dateCheck(data?.dStartDate))}</p>
                  <span className={styles.abbr}>{data?.oTeamB?.sAbbr}</span>
                  <div className={styles.flag}>
                    <MyImage
                      src={data?.oTeamB?.oImg?.sUrl ? `${S3_PREFIX}${data?.oTeamB?.oImg?.sUrl}` : FlagTeam}
                      placeholderImage={FlagTeam}
                      errorImage={FlagTeam}
                      width="162"
                      height="162"
                      alt={data?.oTeamB?.oImg?.sText}
                      autoRadiusImage
                      layout="responsive"
                      sizes="20px"
                    />
                  </div>
                  {data?.oSeo?.sSlug ? <CustomLink href={`/${data?.oSeo?.sSlug}`} prefetch={false}>
                    <a className={`${styles.fullLink} position-absolute`}></a>
                  </CustomLink> : null}
                </div>
              )
            })}

            {loading &&
              [0, 1, 2, 3, 4].map((i) => (
                <div key={i} className={`${styles.item} d-flex justify-content-between align-items-center`}>
                  <Skeleton width="22%" height={'20px'} />
                  <Skeleton width="28%" height={'16px'} />
                  <Skeleton width="22%" height={'20px'} />
                </div>
              ))}
          </div>
        </section>
      )}
    </>
  )
}

export default UpcomingMatches
